export const environment = {
  appUrl: 'https://intestech.com.tr/',
  production: true
};
